(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('productDetail', function ($Products, $state, $q, Upload, $timeout) {
		return {
            scope: {
				product: '='
			},
			templateUrl: 'directives/productDetail/form.html',
			controller: function($scope, $state) {

                //console.log('firebase user', firebase.auth());

                var storage = firebase.storage();
                var storageRef = firebase.storage().ref();

                function removeImage() {

                    $scope.product.productImageRef = null;
                    $scope.product.productImage = null;

                    $scope.save();

                };

                function removeFitGuide() {

                    $scope.product.productFitGuideRef = null;
                    $scope.product.productFitGuide = null;

                    $scope.save();

                };

				$scope.hasProperty = function(product, key) {
					return  _.chain(product.properties || []).pluck('type').contains(key).value();
				};

                $scope.saveProduct = function() {

                    if($scope.product.$id){
                        $scope.save().then(function() {

                            $scope.saveMessageVisible = true;

                            $timeout(function() {

                                // TODO: This doesn't do anything and trhows and error
                                $scope.closeAlert();
                            }, 4000);

                        });
                    } else {

                         $scope.save().then(function(newProduct) {

                             $state.go('product-detail', {id: newProduct.key});

                         });

                    }

                };

                $scope.close = function() {
                    this.save().then(() => {
                        $state.go('products');
                    });
                };

                $scope.save = function() {

                    console.log('product', this.product);

                    return $q(function(resolve, reject){
                        //$Product.set()
                        var result = $Products.add($scope.product);

                        console.log('result', result);

                        resolve(result);

                    })
                };

                $scope.deleteImage = function(uploadType) {

                    // upload type can be a fitGuide or an image

                    let self = this;
                    let deleteImageRef;

                    if(uploadType === 'fitGuide'){

                        deleteImageRef = storageRef.child(self.product.productFitGuideRef);

                    }

                    if(uploadType === 'image'){

                        deleteImageRef = storageRef.child(self.product.productImageRef);
                    }

                    if(deleteImageRef){

                        console.log('deleteImageRef', deleteImageRef);

                        deleteImageRef.delete().then(function() {

                            if(uploadType === 'fitGuide'){

                                removeFitGuide();

                            }

                            if(uploadType === 'image'){

                                removeImage();

                            }

                            // self.product.productImageRef = null;
                            // self.product.productImage = null;
                            //
                            // console.log('file ref deleted');
                            //
                            // self.save();
                            // File deleted successfully
                        }).catch(function(error) {
                            // Uh-oh, an error occurred!
                            console.log('ERROR', error);

                            if(error.code === 'storage/object-not-found'){

                                // remove the image ref if it's there, regardless because we apparently have a missing image
                                if(uploadType === 'fitGuide'){

                                    removeFitGuide();

                                }

                                if(uploadType === 'image'){

                                    removeImage();

                                }

                            }
                        });

                    }

                };

                $scope.uploadImage = function(files, errFiles, uploadType) {

                    // upload type can be a fitGuide or an image

                    var self = this;

                    self.uploading = true;

                    self.files = files;
                    self.errFiles = errFiles;
                    angular.forEach(files, function(file) {

                    //    console.log(file, self.product);

                       var uploadFileTask = storageRef.child(self.product.$id + '/' + file.name).put(file);

                       uploadFileTask.on('state_changed', function(snapshot){
                           // Observe state change events such as progress, pause, and resume
                            self.fileUploadProgress = Math.floor( (snapshot.bytesTransferred / snapshot.totalBytes) * 100 );
                            self.$apply();

                        }, function(error) {
                            // Handle unsuccessful uploads
                        }, function() {

                            //console.log('Upload', uploadFileTask);
                            // Handle successful uploads on complete
                            // For instance, get the download URL: https://firebasestorage.googleapis.com/...

                            if(uploadType === 'fitGuide'){

                                self.product.productFitGuideRef = uploadFileTask.snapshot.ref.fullPath;
                                self.product.productFitGuide = uploadFileTask.snapshot.downloadURL;

                            }

                            if(uploadType === 'image'){

                                self.product.productImageRef = uploadFileTask.snapshot.ref.fullPath;
                                self.product.productImage = uploadFileTask.snapshot.downloadURL;

                            }

                            self.save().then(() => {

                                self.uploading = false;

                            });



                        });
                    });
                };

			}
		};
	});
})();
